export default {
  tableLoading(state, value) {
    return (state.tableLoading = value);
  },

  setStatus(state, value) {
    return (state.status = value);
  },

  currentPage(state, value) {
    return (state.currentPage = value);
  },

  jobApplications(state, projects) {
    state.jobApplications = projects;
  },

  perPage(state, value) {
    return (state.perPage = value);
  },

  setSelectedRow(state, value) {
    state.selectedRow = value;
  },

  searchQuery(state, value) {
    return (state.searchQuery = value);
  },

  paginationTotal(state, value) {
    return (state.total = value);
  },

  resetState(state) {
    state.currentPage = 1;
    state.perPage = 5;
    state.searchQuery = "";
    state.total = 0;
  },
};
